import { pgTable, text, boolean, timestamp, integer, index, uniqueIndex, foreignKey, varchar, jsonb, unique, pgEnum } from 'drizzle-orm/pg-core';
import { sql } from 'drizzle-orm';
import { role } from './rbac';
import { user } from './user';

// Enum для типа актора в аудит-логе
export const auditActorType = pgEnum('AuditActorType', ['ADMIN', 'USER', 'SYSTEM']);

// Таблица администраторов
export const adminUser = pgTable('AdminUser', {
  id: integer().primaryKey().generatedAlwaysAsIdentity(),
  username: varchar({ length: 255 }).notNull(),
  email: varchar({ length: 255 }).notNull(),
  passwordHash: varchar({ length: 255 }),
  roleId: integer(),
  isActive: boolean().default(true),
  lastActivityAt: timestamp({ precision: 3, mode: 'date' }),
  inviteToken: varchar({ length: 255 }),
  inviteExpiresAt: timestamp({ precision: 3, mode: 'date' }),
  resetToken: varchar({ length: 255 }),
  resetExpiresAt: timestamp({ precision: 3, mode: 'date' }),
  createdAt: timestamp({ precision: 3, mode: 'date' }).default(sql`CURRENT_TIMESTAMP`).notNull(),
  updatedAt: timestamp({ precision: 3, mode: 'date' }).notNull(),
}, (table) => [
  index('AdminUser_lastActivityAt_idx').using('btree', table.lastActivityAt.asc().nullsLast()),
  unique('AdminUser_username_key').on(table.username),
  unique('AdminUser_email_key').on(table.email),
  foreignKey({
    columns: [table.roleId],
    foreignColumns: [role.id],
    name: 'AdminUser_roleId_fkey'
  }).onUpdate('cascade').onDelete('set null'),
]);

// Таблица трекинга активности админов
export const adminTrack = pgTable('AdminTrack', {
  id: integer().primaryKey().generatedAlwaysAsIdentity(),
  adminUserId: integer().notNull(),
  lastActivityAt: timestamp({ precision: 3, mode: 'date' }).default(sql`CURRENT_TIMESTAMP`).notNull(),
  createdAt: timestamp({ precision: 3, mode: 'date' }).default(sql`CURRENT_TIMESTAMP`).notNull(),
  updatedAt: timestamp({ precision: 3, mode: 'date' }).notNull(),
}, (table) => [
  uniqueIndex('AdminTrack_adminUserId_key').using('btree', table.adminUserId.asc().nullsLast()),
  index('AdminTrack_lastActivityAt_idx').using('btree', table.lastActivityAt.asc().nullsLast()),
  foreignKey({
    columns: [table.adminUserId],
    foreignColumns: [adminUser.id],
    name: 'AdminTrack_adminUserId_fkey'
  }).onUpdate('cascade').onDelete('cascade'),
]);

// Таблица аудит-логов
export const auditLog = pgTable('AuditLog', {
  id: integer().primaryKey().generatedAlwaysAsIdentity(),
  adminId: integer(),
  userId: integer(),
  actorType: auditActorType().notNull().default('ADMIN'),
  action: text().notNull(),
  entityType: text().notNull(),
  entityId: text().notNull(),
  oldData: jsonb(),
  newData: jsonb(),
  ipAddress: text(),
  userAgent: text(),
  createdAt: timestamp({ precision: 3, mode: 'date' }).default(sql`CURRENT_TIMESTAMP`).notNull(),
}, (table) => [
  index('AuditLog_action_idx').using('btree', table.action.asc().nullsLast()),
  index('AuditLog_adminId_idx').using('btree', table.adminId.asc().nullsLast()),
  index('AuditLog_userId_idx').using('btree', table.userId.asc().nullsLast()),
  index('AuditLog_actorType_idx').using('btree', table.actorType.asc().nullsLast()),
  index('AuditLog_createdAt_idx').using('btree', table.createdAt.asc().nullsLast()),
  index('AuditLog_entityType_idx').using('btree', table.entityType.asc().nullsLast()),
  foreignKey({
    columns: [table.adminId],
    foreignColumns: [adminUser.id],
    name: 'AuditLog_adminId_fkey'
  }).onUpdate('cascade').onDelete('set null'),
  foreignKey({
    columns: [table.userId],
    foreignColumns: [user.id],
    name: 'AuditLog_userId_fkey'
  }).onUpdate('cascade').onDelete('set null'),
]);

// Таблица менеджеров (связь админ -> телеграм сессия)
export const manager = pgTable('Manager', {
  id: integer().primaryKey().generatedAlwaysAsIdentity(),
  adminUserId: integer().notNull(),
  telegramPhone: text(),
  sessionString: text(),
  createdAt: timestamp({ precision: 3, mode: 'date' }).default(sql`CURRENT_TIMESTAMP`).notNull(),
  updatedAt: timestamp({ precision: 3, mode: 'date' }).notNull(),
}, (table) => [
  uniqueIndex('Manager_adminUserId_key').using('btree', table.adminUserId.asc().nullsLast()),
  foreignKey({
    columns: [table.adminUserId],
    foreignColumns: [adminUser.id],
    name: 'Manager_adminUserId_fkey'
  }).onUpdate('cascade').onDelete('cascade'),
]);
